module.exports = __webpack_public_path__ + "img/18.53e7880.jpg";